import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as s } from "../chunks/tslib.es6.js";
import e from "./Accessor.js";
import { assumeNonNull as i } from "./maybe.js";
import { createDeferred as r, createAbortError as t, isAbortError as o } from "./promiseUtils.js";
import { subclass as l } from "./accessorSupport/decorators/subclass.js";

var h = /*#__PURE__*/function () {
  function h(s) {
    var _this = this;

    _classCallCheck(this, h);

    this.instance = s, this._resolver = r(), this._status = 0, this._resolvingPromises = [], this._resolver.promise.then(function () {
      _this._status = 1, _this._cleanUp();
    }, function () {
      _this._status = 2, _this._cleanUp();
    });
  }

  _createClass(h, [{
    key: "addResolvingPromise",
    value: function addResolvingPromise(s) {
      this._resolvingPromises.push(s), this._tryResolve();
    }
  }, {
    key: "isResolved",
    value: function isResolved() {
      return 1 === this._status;
    }
  }, {
    key: "isRejected",
    value: function isRejected() {
      return 2 === this._status;
    }
  }, {
    key: "isFulfilled",
    value: function isFulfilled() {
      return 0 !== this._status;
    }
  }, {
    key: "abort",
    value: function abort() {
      this._resolver.reject(t());
    }
  }, {
    key: "when",
    value: function when(s, e) {
      return this._resolver.promise.then(s, e);
    }
  }, {
    key: "_cleanUp",
    value: function _cleanUp() {
      this._allPromise = this._resolvingPromises = this._allPromise = null;
    }
  }, {
    key: "_tryResolve",
    value: function _tryResolve() {
      var _this2 = this;

      if (this.isFulfilled()) return;
      var s = r(),
          e = [].concat(_toConsumableArray(this._resolvingPromises), [i(s.promise)]),
          t = this._allPromise = Promise.all(e);
      t.then(function () {
        _this2.isFulfilled() || _this2._allPromise !== t || _this2._resolver.resolve(_this2.instance);
      }, function (s) {
        _this2.isFulfilled() || _this2._allPromise !== t || o(s) || _this2._resolver.reject(s);
      }), s.resolve();
    }
  }]);

  return h;
}();

var n = function n(e) {
  var i = /*#__PURE__*/function (_e) {
    _inherits(i, _e);

    var _super = _createSuper(i);

    function i() {
      var _this3;

      _classCallCheck(this, i);

      for (var _len = arguments.length, s = new Array(_len), _key = 0; _key < _len; _key++) {
        s[_key] = arguments[_key];
      }

      _this3 = _super.call.apply(_super, [this].concat(s)), _this3._promiseProps = new h(_assertThisInitialized(_this3)), _this3.addResolvingPromise(Promise.resolve());
      return _this3;
    }

    _createClass(i, [{
      key: "isResolved",
      value: function isResolved() {
        return this._promiseProps.isResolved();
      }
    }, {
      key: "isRejected",
      value: function isRejected() {
        return this._promiseProps.isRejected();
      }
    }, {
      key: "isFulfilled",
      value: function isFulfilled() {
        return this._promiseProps.isFulfilled();
      }
    }, {
      key: "when",
      value: function when(s, e) {
        var _this4 = this;

        return new Promise(function (s, e) {
          _this4._promiseProps.when(s, e);
        }).then(s, e);
      }
    }, {
      key: "catch",
      value: function _catch(s) {
        return this.when(null, s);
      }
    }, {
      key: "addResolvingPromise",
      value: function addResolvingPromise(s) {
        s && !this._promiseProps.isFulfilled() && this._promiseProps.addResolvingPromise("_promiseProps" in s ? s.when() : s);
      }
    }]);

    return i;
  }(e);

  return i = s([l("esri.core.Promise")], i), i;
};

var m = /*#__PURE__*/function (_n) {
  _inherits(m, _n);

  var _super2 = _createSuper(m);

  function m() {
    _classCallCheck(this, m);

    return _super2.apply(this, arguments);
  }

  return m;
}(n(e));

m = s([l("esri.core.Promise")], m);
export { m as EsriPromise, n as EsriPromiseMixin };